import { apiClient } from '@/libs/api_client'
import axios from 'axios'
import { ApiResponse, ExaminationRoom } from '@magnetar/admin-api-interfaces'

export type CreateExaminationRoomData = {
  clinic_id: number
  name: string
  department: string
}

export type UpdateExaminationRoomData = {
  examination_room_id: number
  clinic_id: number
  name: string
  department: string
  is_active: boolean
  patient_flow_device_ip?: string
}

export type CreateExaminationVodData = {
  examination_room_id: number
  source: string
  vod_name: string
  order?: number
  is_active: boolean
}

export type UpdateExaminationVodData = {
  vod_id: number
  source?: string
  vod_name?: string
  order?: number
  is_active?: boolean
}

export const examinationRoomService = {
  createExaminationRoom: async (data: CreateExaminationRoomData, token: string) => {
    try {
      const response = await apiClient.post<ApiResponse<ExaminationRoom>>(
        '/api/examination-rooms',
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
      }
    }
  },

  updateExaminationRoom: async (data: UpdateExaminationRoomData, token: string) => {
    try {
      const response = await apiClient.put<ApiResponse<ExaminationRoom>>(
        `/api/examination-rooms/${data.examination_room_id}`,
        {
          clinic_id: data.clinic_id,
          name: data.name,
          department: data.department,
          is_active: data.is_active,
          patient_flow_device_ip: data.patient_flow_device_ip,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
      }
    }
  },

  deleteExaminationRoom: async (examinationRoomId: number, token: string) => {
    try {
      const response = await apiClient.delete<ApiResponse<void>>(
        `/api/examination-rooms/${examinationRoomId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data
      }
      return {
        success: false,
      }
    }
  },
}
